/**
 * Body paragraph with optional muted styling.
 *
 * @param body - Visible text.
 * @param options - When **`muted`** is true, applies secondary text colour.
 * @returns **`p`** element.
 */
export function createText(
  body: string,
  options?: Readonly<{ muted?: boolean }>,
): HTMLParagraphElement {
  const p = document.createElement("p");
  p.textContent = body;
  p.className = options?.muted ? "qz-text qz-text--muted" : "qz-text";
  return p;
}
